import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { AllMeetingStatus, MeetingRecord } from 'type/meeting';
import MeetingInfo from './MeetingInfo';
import noMeetingImg from 'asset/image/kts_meeting.png';
import style from './Schedule.module.scss';
import moment from 'moment';

interface IProps {
  from?: string;
  loading?: boolean;
  records: MeetingRecord[];
  refresh?: any;
}

const Schedule: React.FC<IProps> = (props) => {
  const { from, loading = false, records, refresh } = props;

  const [group, setGroup] = useState({
    yet: [],
    past: []
  } as { yet: MeetingRecord[]; past: MeetingRecord[] });

  useEffect(() => {
    if (!records || !records.length) return;
    const yet: MeetingRecord[] = [];
    const past: MeetingRecord[] = [];

    const sorted = [...records].sort((r1, r2) => r1.meeting.beginTime - r2.meeting.beginTime);

    const curTime = moment().valueOf();
    sorted.forEach((r) => {
      if (r.meeting.status === AllMeetingStatus.FINISH || r.meeting.status === AllMeetingStatus.FILED || curTime >= r.meeting.endTime) {
        past.push(r);
      } else {
        yet.push(r);
      }
    });
    setGroup({
      yet,
      past
    });
  }, [records]);

  return (
    <div className={style.warp}>
      <Spin spinning={loading}>
        {records && records.length > 0 ? (
          <>
            {group.yet.length > 0 && (
              <>
                <div className={style.groupTitle}>当日安排</div>
                <div>
                  {group.yet.map((r) => (
                    <MeetingInfo key={r.meeting.meetingNo} refresh={refresh} from={from} record={r} />
                  ))}
                </div>
              </>
            )}
            {group.past.length > 0 && (
              <>
                <div className={style.groupTitle} style={{ marginTop: group.yet.length > 0 ? '38px' : 0 }}>
                  已结束
                </div>
                <div>
                  {group.past.map((r) => (
                    <MeetingInfo key={r.meeting.meetingNo} from={from} record={r} />
                  ))}
                </div>
              </>
            )}
          </>
        ) : (
          <div className={style.noMeetingTips}>
            <img src={noMeetingImg} className={style.img}></img>
            <div className={style.text}>暂无会议安排</div>
          </div>
        )}
      </Spin>
    </div>
  );
};

export default Schedule;
